import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import ButcherPaper from '../ButcherPaper';

interface Props {
  white?: boolean;
  dark?: boolean;
  black?: boolean;
  texture?: boolean;
  butcherPaper?: boolean;
  backgroundImageUrl?: string | null;
  children: React.ReactNode;
  className?: string;
  height?: string;
  basePadding?: boolean;
  largePadding?: boolean;
  gutterX?: boolean;
  gutterY?: boolean;
  zIndexNone?: boolean;
  monetateTestId?: string;
  rootRef?: any;
  [val: string]: any;
}

const Section = ({
  butcherPaper,
  children,
  basePadding,
  largePadding,
  rootRef,
  className,
  darkGray,
  white,
  black,
  dark,
  zIndexNone,
  backgroundImageUrl,
  gutterY,
  gutterX,
  texture,
  componentHeight,
  dataTestId,
  ariaLabel,
  monetateTestId,
  as: Element = 'div',
}: Props) => {
  return (
    <Element
      data-testid={dataTestId}
      data-test-id={monetateTestId}
      aria-label={ariaLabel}
      className={classNames(
        dark && butcherPaper && 'tw-bg-surface-700',
        dark && !butcherPaper && 'tw-bg-surface-800',
        white && 'tw-bg-text-100',
        black && 'tw-bg-surface-900',
        darkGray ? 'tw-bg-surface-700' : 'tw-bg-surface-100',
        zIndexNone ? 'tw-z-0' : 'tw-z-[100]',
        backgroundImageUrl && 'tw-bg-cover tw-bg-no-repeat tw-bg-center',
        gutterX && 'tw-px-gutterXS sm:tw-px-gutterLG',
        gutterY && 'tw-py-gutterXS sm:tw-py-gutterLG',
        basePadding && 'tw-py-2 sm:tw-py-3',
        largePadding && 'tw-py-3 sm:tw-py-4',
        texture && 'tw-bg-speckle tw-bg-fixed',
        className,
        'section tw-relative tw-h-full [&_.section]:tw-bg-transparent',
      )}
      style={{
        backgroundImage: (backgroundImageUrl && `url(${backgroundImageUrl})`) ?? '',
        height: componentHeight && `${componentHeight}`,
      }}
      ref={rootRef}
    >
      {butcherPaper && <ButcherPaper className={classNames('butcher-paper')} />}
      {children}
    </Element>
  );
};

export default Section;
